import { render, staticRenderFns } from "./InvestmentTransactions.vue?vue&type=template&id=0fa0f738&scoped=true&"
import script from "./InvestmentTransactions.vue?vue&type=script&lang=js&"
export * from "./InvestmentTransactions.vue?vue&type=script&lang=js&"
import style0 from "./InvestmentTransactions.vue?vue&type=style&index=0&id=0fa0f738&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa0f738",
  null
  
)

export default component.exports